/*
 * uploadWidgetTableModule
 * */

import uploadWidgetTableComponent from './uploadWidgetTable.directive';

const uploadWidgetTableModule = angular.module('app.components.dashboard.uploadWidget.uploadWidgetTable', [])
	.directive('uploadWidgetTable', uploadWidgetTableComponent)
	.name;

export default uploadWidgetTableModule;
